import { MainContentLayout } from 'shared/ui/layout';

import { AddPerson } from 'features/person/add-person';

export function AddPersonPage() {
  return <MainContentLayout element={<AddPerson />} />;
}
